/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createConj } from '../../factoriesAny.js';
export var conjDependencies = {
  typedDependencies,
  createConj
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesConj.generated.js
// module id = b+PH
// module chunks = 3